import { Link } from "react-router"

export default function CuisineTile({ cuisine }){
    return (
        <Link
            to={`/restaurant?search=${encodeURIComponent(cuisine.name)}`}
            className="flex flex-col items-center justify-center gap-2 w-28 h-28 bg-charcoal rounded-2xl border border-transparent hover:border-turmeric transition transform hover:-translate-y-1"
        >
            <span className="text-4xl">{cuisine.emoji}</span>
            <span className="text-cream text-xs font-medium text-center px-1">{cuisine.name}</span>
        </Link>
    )
}
